import { useMutation } from '@apollo/client/react';
import { gql } from '@apollo/client';

const CREATE_DIARY_ENTRY_MUTATION = gql`
  mutation CreateDiaryEntry($input: CreateDiaryEntryInput!) {
    createDiaryEntry(input: $input) {
      diaryEntry {
        id
        date
        description
        tag {
          id
          name
          slug
        }
        status
        weather
        author {
          id
          fullName
        }
        createdAt
      }
    }
  }
`;

export interface CreateDiaryEntryInput {
  siteInspectionId: string;
  date: string;
  description: string;
  tagSlug?: string;
  status: string;
  weather?: string;
  documentUploads?: File[];
}

export function useCreateDiaryEntry() {
  const [mutation, { loading, error }] = useMutation(CREATE_DIARY_ENTRY_MUTATION);

  const createDiaryEntry = async (input: CreateDiaryEntryInput) => {
    const { documentUploads, ...rest } = input;
    const variables: Record<string, unknown> = { input: rest };
    if (documentUploads?.length) variables.documentUploads = documentUploads;
    const { data } = await mutation({ variables });
    return (data as any)?.createDiaryEntry?.diaryEntry;
  };

  return { createDiaryEntry, loading, error };
}
